import React, { useEffect, useState } from 'react'


export default function RenderTableCard({ render, index }) {
    const [updatedIndex, setUpdatedIndex] = useState(index)
    useEffect(() => {
        setUpdatedIndex(index)
    }, [index])
    return (
        <>
            {render[updatedIndex]}
        </>
    )
}